export function simpleHash(str: string) {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32-bit integer
  }
  return hash >>> 0; // Return as unsigned
}

export function obfuscateEmailAddress(email: string) {
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email; // Not a valid email

  const username = email.slice(0, atIndex);
  const domain = email.slice(atIndex);

  if (username.length <= 2) {
    return `${username}${domain}`;
  }

  const firstChar = username.charAt(0);
  const lastChar = username.charAt(username.length - 1);
  const obscured = firstChar + '*'.repeat(username.length - 2) + lastChar;
  return obscured + domain;
}

export function truncateText(text: string | undefined, maxLength: number) {
  if (!text) return text;
  return text.length > maxLength ? text.substring(0, maxLength) : text;
}
